<h2 class="mt-3 mb-4">Change Password</h2>
<div class="notice notice-error" *ngIf="error">
  <div class="notice-body">Failed to change password<br>{{ error?.description }}</div>
</div>
<div class="notice" *ngIf="success">
  <div class="notice-body">Successfully changed password</div>
</div>
<div class="notice" *ngIf="f.password.touched && f.password.value == ''">
  <div class="notice-body">New password is currently blank and will not be changed.</div>
</div>

<form [formGroup]="ChangePasswordForm" class="material-form-grid">

  <app-all-seeing-eye label="New Password" formControlName="password"></app-all-seeing-eye>

  <app-all-seeing-eye label="Confirm New Password" formControlName="confirm" class="mgl-15"></app-all-seeing-eye>

  <app-all-seeing-eye class="full-width" label="Current Password" formControlName="currentpass" hintText="Required for authorisation">
  </app-all-seeing-eye>

  <div class="form-actions full-width">
    <button mat-flat-button color="primary" id="change-password-button" type="button" (click)="changePassword()"
      [disabled]="changePasswordDisabled()">
      <mat-spinner *ngIf="changing" diameter="20" mode="indeterminate"></mat-spinner>
      {{ changing ? 'Changing' : 'Change Password' }}
    </button>
  </div>

</form>
